import styled from 'styled-components';
import horizontalScrollbarStyles from '../styles/horizontalScrollbarStyles';
var Inner = styled.div.withConfig({
  displayName: "Inner",
  componentId: "sc-75bgn1-0"
})(["display:block;overflow-x:scroll;overflow-y:hidden;padding:0;position:relative;-webkit-overflow-scrolling:touch;", ""], horizontalScrollbarStyles);
export default Inner;